(function () {
  "use strict";

  var VERSION = "20260713-welcome-format-experiment-v1";
  if (window.__tk9WelcomeFormatExperimentVersion === VERSION) return;
  window.__tk9WelcomeFormatExperimentVersion = VERSION;

  var config = Object.assign({
    enabled: false,
    experimentId: "welcome_format_v1_20260713",
    fetchPopupId: "0b9fdc9b-4979-41eb-b47d-63adc389256e",
    mysteryPopupId: "b803260b-220b-4305-98c3-db5ae92637ff",
    fetchWeight: 0.5,
    triggerDelayMs: 6000,
    triggerScrollRatio: 0.25,
    assignmentTtlDays: 30,
    sdkRetryLimit: 8,
    telemetryEndpoint: "https://teamk9-welcome-telemetry.teamk9-guard.workers.dev/welcome-telemetry",
    assignmentStorageKey: "tk9_welcome_format_experiment_v1",
    sessionDismissStorageKey: "tk9_fetch_welcome_game_r1",
    completionStorageKey: "tk9_fetch_welcome_game_r1",
    forceVariantParam: "tk9_welcome_variant",
    forceExperimentParam: "tk9_welcome_experiment",
    excludeCustomer: false,
    offerCode: "WELCOME"
  }, window.TeamK9WelcomeFormatExperimentConfig || {});

  var params;
  try { params = new URLSearchParams(window.location.search); }
  catch (error) { params = { get: function () { return ""; } }; }
  var forcedVariant = String(params.get(config.forceVariantParam) || "").toLowerCase();
  if (forcedVariant !== "fetch" && forcedVariant !== "mystery") forcedVariant = "";
  var forceExperiment = /^(?:1|on|force)$/i.test(String(params.get(config.forceExperimentParam) || ""));
  var legacyForceFetch = /^(?:1|on|force)$/i.test(String(params.get("tk9_fetch_game") || ""));
  if (legacyForceFetch && !forcedVariant) forcedVariant = "fetch";
  if (legacyForceFetch) forceExperiment = true;

  function isCartPath() {
    var path = String(window.location.pathname || "/").replace(/\/+$/, "") || "/";
    return path === "/cart" || /^\/[a-z]{2}(?:-[a-z]{2})?\/cart$/i.test(path);
  }

  function alreadyCompleted() {
    try {
      return window.localStorage.getItem(config.completionStorageKey) === "completed" ||
        Boolean(window.localStorage.getItem("tk9_welcome_code_unlocked"));
    } catch (error) { return false; }
  }

  function alreadyDismissed() {
    try { return window.sessionStorage.getItem(config.sessionDismissStorageKey) === "dismissed"; }
    catch (error) { return false; }
  }

  function knownSubscriber() {
    try {
      return Boolean(window.postscript && typeof window.postscript.getSubscriberId === "function" && window.postscript.getSubscriberId());
    } catch (error) { return false; }
  }

  function commerceOverlayOpen() {
    return document.documentElement.classList.contains("tk9-slide-cart-lock") ||
      Boolean(document.body && document.body.classList.contains("tk9-slide-cart-lock")) ||
      Boolean(document.querySelector("[data-tk9-slide-cart].is-open,[data-tk9-slide-cart][aria-hidden='false']"));
  }

  if ((!config.enabled && !forceExperiment) || isCartPath()) return;
  if (!forceExperiment && (config.excludeCustomer || alreadyCompleted() || alreadyDismissed())) return;
  if (!config.fetchPopupId || !config.mysteryPopupId) return;

  function randomId() {
    try { return window.crypto.randomUUID(); }
    catch (error) { return "welcome-" + Date.now() + "-" + Math.random().toString(36).slice(2); }
  }

  function randomUnit() {
    try {
      var values = new Uint32Array(1);
      window.crypto.getRandomValues(values);
      return values[0] / 4294967296;
    } catch (error) { return Math.random(); }
  }

  function readAssignment() {
    if (forcedVariant) return { experiment: config.experimentId, variant: forcedVariant, assignedAt: new Date().toISOString(), forced: true };
    try {
      var stored = JSON.parse(window.localStorage.getItem(config.assignmentStorageKey) || "null");
      var age = Date.now() - Date.parse(stored && stored.assignedAt || "");
      var ttl = Math.max(1, Number(config.assignmentTtlDays || 30)) * 86400000;
      if (stored && stored.experiment === config.experimentId && /^(?:fetch|mystery)$/.test(stored.variant) && age >= 0 && age < ttl) return stored;
    } catch (error) {}
    var assignment = {
      experiment: config.experimentId,
      variant: randomUnit() < Math.max(0, Math.min(1, Number(config.fetchWeight || 0.5))) ? "fetch" : "mystery",
      assignedAt: new Date().toISOString()
    };
    try { window.localStorage.setItem(config.assignmentStorageKey, JSON.stringify(assignment)); }
    catch (error) {}
    return assignment;
  }

  var assignment = readAssignment();
  var popupId = assignment.variant === "fetch" ? config.fetchPopupId : config.mysteryPopupId;
  var state = {
    id: randomId(),
    armed: false,
    exposed: false,
    engaged: false,
    popupOpened: false,
    emailSubmitted: false,
    phoneSubmitted: false,
    subscriberCreated: false,
    closed: false,
    controlRequested: false,
    triggerTimer: 0,
    sdkRetryTimer: 0,
    openConfirmTimer: 0,
    sdkAttempts: 0,
    trigger: "unknown",
    cartAttributed: false
  };

  var productPathRules = [
    { match: /custom-patch|patches-bundle|hook-loop-patch|patch-for-harness/i, path: "custom_patches", family: "patches_message" },
    { match: /tactical-leash|bungee-dog-leash|dog-leash/i, path: "tactical_leash", family: "harness_walk" },
    { match: /tactical-pouch|dog-pouch/i, path: "tactical_pouch", family: "harness_walk" },
    { match: /dog-collar|tactical-collar/i, path: "dog_collar", family: "harness_walk" },
    { match: /all-metal-tactical-harness|metal-buckle-harness|dog-harness/i, path: "metal_buckle_harness", family: "harness_walk" },
    { match: /dual-headrest-cooling-fans|cooling-fan|headrest-fan/i, path: "backseat_cooling_fans", family: "car_travel" },
    { match: /hard-bottom-csce|single-seat-cover|seat-cover|backseat-dog-bed|cargo-cover/i, path: "hard_bottom_seat_cover", family: "car_travel" },
    { match: /pet-car-safety-belt|car-safety-belt|seat-belt/i, path: "car_safety_belt", family: "car_travel" },
    { match: /travel-bowl|water-bowl/i, path: "travel_bowl", family: "car_travel" },
    { match: /dog-goggles|doggles|goggle|eye-protection/i, path: "doggles", family: "doggles_eye_protection" },
    { match: /waterproof-dog-pool-cover|dog-pool-cover|pool-cover/i, path: "dog_pool_cover", family: "pool_backyard" },
    { match: /dog-pool|foldable-pool|pet-pool/i, path: "dog_pool", family: "pool_backyard" },
    { match: /first-aid/i, path: "first_aid_kit", family: "safety_first_aid" }
  ];

  function productHandle() {
    var match = String(window.location.pathname || "").match(/\/products\/([^/?#]+)/i);
    return match ? match[1] : "";
  }

  function productRoute() {
    var value = String(window.location.pathname || "") + " " + productHandle();
    for (var index = 0; index < productPathRules.length; index += 1) {
      if (productPathRules[index].match.test(value)) return productPathRules[index];
    }
    return { path: "unclassified_product_path", family: "unclassified_product_path" };
  }

  function deviceType() {
    return window.matchMedia && window.matchMedia("(max-width: 759px)").matches ? "mobile" : "desktop";
  }

  function basePayload(name, detail) {
    var route = productRoute();
    return Object.assign({
      event: name,
      tk9_experiment: config.experimentId,
      tk9_variant: assignment.variant,
      tk9_session_id: state.id,
      tk9_popup_id: popupId,
      tk9_popup_variant: assignment.variant === "fetch" ? "welcome_fetch_game" : "welcome_mystery_control",
      tk9_trigger: state.trigger,
      tk9_offer_code: config.offerCode,
      tk9_entry_path: String(window.location.pathname || "/"),
      tk9_product_handle: productHandle(),
      tk9_product_path_interest: route.path,
      tk9_product_family: route.family,
      tk9_device: deviceType(),
      tk9_at: new Date().toISOString()
    }, detail || {});
  }

  function sendTelemetry(payload) {
    if (!config.telemetryEndpoint) return;
    var body;
    try {
      body = JSON.stringify({
        event: payload.event,
        session_id: payload.tk9_session_id,
        experiment: payload.tk9_experiment,
        variant: payload.tk9_variant,
        popup_id: payload.tk9_popup_id,
        reason: String(payload.tk9_reason || "").slice(0, 80),
        device: payload.tk9_device,
        product_handle: payload.tk9_product_handle,
        product_path: payload.tk9_product_path_interest,
        product_family: payload.tk9_product_family,
        popup_variant: payload.tk9_popup_variant,
        trigger: payload.tk9_trigger,
        attempt: Number(payload.tk9_attempt || 0),
        client_at: payload.tk9_at
      });
    } catch (error) { return; }
    function beaconFallback() {
      try {
        if (navigator.sendBeacon) navigator.sendBeacon(config.telemetryEndpoint, new Blob([body], { type: "application/json" }));
      } catch (error) {}
    }
    try {
      window.fetch(config.telemetryEndpoint, {
        method: "POST",
        credentials: "omit",
        keepalive: true,
        headers: { "Content-Type": "text/plain;charset=UTF-8" },
        body: body
      }).catch(beaconFallback);
    } catch (error) { beaconFallback(); }
  }

  function track(name, detail) {
    var payload = basePayload(name, detail);
    sendTelemetry(payload);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    try {
      window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
      window.gtag("event", name, Object.assign({ transport_type: "beacon" }, payload));
    } catch (error) {}
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish(name, payload);
    } catch (error) {}
    try { if (typeof window.fbq === "function") window.fbq("trackCustom", name, payload); }
    catch (error) {}
    try {
      var queue = window.klaviyo && typeof window.klaviyo.push === "function" ? window.klaviyo : (window.klaviyo = window.klaviyo || []);
      queue.push(["track", "WELCOME Format Experiment", {
        tk9_event: name,
        tk9_experiment: config.experimentId,
        tk9_variant: assignment.variant,
        tk9_session_id: state.id,
        tk9_popup_id: popupId,
        tk9_trigger: state.trigger,
        tk9_product_handle: payload.tk9_product_handle,
        tk9_product_path_interest: payload.tk9_product_path_interest,
        tk9_product_family: payload.tk9_product_family,
        tk9_device: payload.tk9_device,
        tk9_at: payload.tk9_at
      }]);
    } catch (error) {}
    try { window.dispatchEvent(new CustomEvent(name, { detail: payload })); }
    catch (error) {}
  }

  function routeTeaser() {
    try { window.sessionStorage.setItem("tk9_dog_offer_teaser_active_popup", popupId); }
    catch (error) {}
    try {
      if (window.TeamK9DogOfferTeaser && typeof window.TeamK9DogOfferTeaser.setPopupId === "function") window.TeamK9DogOfferTeaser.setPopupId(popupId);
    } catch (error) {}
  }

  function persistCartAttribution() {
    if (state.cartAttributed) return;
    state.cartAttributed = true;
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/";
    var endpoint = root.replace(/\/?$/, "/") + "cart/update.js";
    try {
      window.fetch(endpoint, {
        method: "POST",
        credentials: "same-origin",
        keepalive: true,
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ attributes: {
          _tk9_welcome_experiment: config.experimentId,
          _tk9_welcome_variant: assignment.variant,
          _tk9_welcome_session: state.id
        } })
      }).catch(function () {});
    } catch (error) {}
  }

  function recordExposure(source) {
    if (state.exposed) return;
    state.exposed = true;
    state.trigger = source || state.trigger || "unknown";
    routeTeaser();
    persistCartAttribution();
    track("tk9_welcome_experiment_exposure");
  }

  function recordEngagement(reason) {
    if (state.engaged) return;
    state.engaged = true;
    track("tk9_welcome_experiment_engaged", { tk9_reason: reason || "interaction" });
  }

  function syncExperimentProfile(email) {
    var normalized = String(email || "").trim().toLowerCase();
    if (!normalized || normalized.indexOf("@") < 1) return;
    var route = productRoute();
    try {
      var queue = window.klaviyo && typeof window.klaviyo.push === "function" ? window.klaviyo : (window.klaviyo = window.klaviyo || []);
      queue.push(["identify", {
        email: normalized,
        tk9_welcome_experiment_id: config.experimentId,
        tk9_welcome_experiment_variant: assignment.variant,
        tk9_welcome_experiment_session_id: state.id,
        tk9_welcome_experiment_assigned_at: assignment.assignedAt,
        tk9_welcome_source: assignment.variant === "fetch" ? "welcome_fetch_game" : "welcome_mystery_control",
        tk9_welcome_offer_code: config.offerCode,
        tk9_popup_id: popupId,
        tk9_popup_variant: assignment.variant === "fetch" ? "welcome_fetch_game" : "welcome_mystery_control",
        tk9_signup_path: String(window.location.pathname || "/"),
        tk9_product_handle: productHandle(),
        tk9_product_path_interest: route.path,
        tk9_product_family: route.family,
        tk9_hero_family_interest: route.family,
        tk9_welcome_trigger: state.trigger,
        tk9_welcome_device: deviceType()
      }]);
    } catch (error) {}
  }

  function installLifecycleTracking() {
    window.addEventListener("tk9_fetch_impression", function () { recordExposure("fetch_game"); });
    window.addEventListener("tk9_fetch_game_started", function () { recordEngagement("fetch_start"); });
    window.addEventListener("postscriptPopup", function (event) {
      var detail = event && event.detail || {};
      if (String(detail.popupId || "") !== String(popupId)) return;
      var values = detail.values && typeof detail.values === "object" ? detail.values : {};
      if (detail.type === "impression") {
        window.clearTimeout(state.openConfirmTimer);
        state.openConfirmTimer = 0;
        if (!state.exposed) recordExposure("teaser_reentry");
        if (!state.popupOpened) {
          state.popupOpened = true;
          track("tk9_welcome_postscript_opened");
        }
      } else if (detail.type === "formSubmit") {
        recordEngagement(values.email ? "email_submit" : values.phone ? "phone_submit" : "micro_yes");
        if (values.email && !state.emailSubmitted) {
          state.emailSubmitted = true;
          syncExperimentProfile(values.email);
          track("tk9_welcome_email_submitted");
        }
        if (values.phone && !state.phoneSubmitted) {
          state.phoneSubmitted = true;
          track("tk9_welcome_phone_submitted");
        }
      } else if (detail.type === "subscriberCreated" && !state.subscriberCreated) {
        state.subscriberCreated = true;
        track("tk9_welcome_subscriber_created");
      } else if (detail.type === "close" && !state.closed) {
        state.closed = true;
        try { window.sessionStorage.setItem(config.sessionDismissStorageKey, "dismissed"); }
        catch (error) {}
        track("tk9_welcome_closed", { tk9_hard_close: Boolean(detail.hard) });
      }
    });
  }

  function showFetch(source) {
    recordExposure(source);
    if (window.TeamK9FetchWelcomeGame && typeof window.TeamK9FetchWelcomeGame.show === "function") {
      window.TeamK9FetchWelcomeGame.show();
      return;
    }
    track("tk9_welcome_postscript_error", { tk9_reason: "fetch_game_unavailable" });
  }

  function showMystery(source) {
    if (state.controlRequested) return;
    if (!state.exposed) recordExposure(source);
    var popups = window.postscript && window.postscript.popups;
    if (!popups || typeof popups.open !== "function") {
      if (state.sdkAttempts < config.sdkRetryLimit) {
        state.sdkAttempts += 1;
        state.sdkRetryTimer = window.setTimeout(function () { showMystery(source); }, 250);
      } else {
        track("tk9_welcome_postscript_error", { tk9_reason: "sdk_unavailable" });
      }
      return;
    }
    window.clearTimeout(state.sdkRetryTimer);
    state.sdkRetryTimer = 0;
    state.controlRequested = true;
    try {
      var openResult = popups.open(config.mysteryPopupId, {
        activePopupBehavior: "ALWAYS_DISMISS",
        respectPopupStatus: false,
        respectCooldown: false
      });
      if (openResult && typeof openResult.catch === "function") {
        openResult.catch(function () {
          if (state.popupOpened) return;
          state.controlRequested = false;
          window.clearTimeout(state.openConfirmTimer);
          state.openConfirmTimer = 0;
          track("tk9_welcome_postscript_error", { tk9_reason: "open_rejected" });
        });
      }
      state.openConfirmTimer = window.setTimeout(function () {
        if (state.popupOpened) return;
        state.controlRequested = false;
        track("tk9_welcome_postscript_error", { tk9_reason: "open_unconfirmed" });
      }, 5000);
    } catch (error) {
      state.controlRequested = false;
      track("tk9_welcome_postscript_error", { tk9_reason: "open_exception" });
    }
  }

  function showAssigned(source) {
    if (state.exposed || (!forceExperiment && knownSubscriber())) return;
    if (commerceOverlayOpen()) return;
    window.clearTimeout(state.triggerTimer);
    window.removeEventListener("scroll", onScroll);
    routeTeaser();
    if (assignment.variant === "fetch") showFetch(source);
    else showMystery(source);
  }

  function scrollRatio() {
    var root = document.documentElement;
    var max = Math.max(1, root.scrollHeight - window.innerHeight);
    return Math.max(0, window.scrollY || root.scrollTop || 0) / max;
  }

  function onScroll() {
    if (scrollRatio() < config.triggerScrollRatio) return;
    showAssigned("scroll_25");
  }

  function arm() {
    if (state.armed) return;
    state.armed = true;
    routeTeaser();
    if (forceExperiment) {
      window.setTimeout(function () { showAssigned("force"); }, 50);
      return;
    }
    state.triggerTimer = window.setTimeout(function () { showAssigned("delay_6s"); }, config.triggerDelayMs);
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  installLifecycleTracking();
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", arm, { once: true });
  else arm();

  window.TeamK9WelcomeFormatExperiment = {
    version: VERSION,
    experimentId: config.experimentId,
    variant: assignment.variant,
    popupId: popupId,
    show: function () { showAssigned("api"); },
    state: state
  };
})();
